import { render, staticRenderFns } from "./SlcHelpDropDown.vue?vue&type=template&id=23641609&"
import script from "./SlcHelpDropDown.vue?vue&type=script&lang=js&"
export * from "./SlcHelpDropDown.vue?vue&type=script&lang=js&"
import style0 from "./SlcHelpDropDown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
